<template>
  <div>
    <div class="app-title">
      <div>
        <h2>{{ $t("tlt.qualityData.write") }}</h2>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>          
          <li class="breadcrumb-item">
            <router-link to="/prd/qualityPlan">
              <span>{{$t('tlt.qualityPlan')}}</span>
            </router-link>
          </li>
          <li class="breadcrumb-item">
           <router-link :to="{path:'/prd/qualityData', query:{id: qualityPlanStatus.id}}">
              <span>{{$t('tlt.qualityData.write')}}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <section class="app-content">
      <div class="card">
        <div class="card-body">
          <form>
            <div class="row">
              <div class="form-group col-md-2">
                <label class="control-label">{{$t('lbl.qualityPlan.planCode')}}:</label>
                <input
                  class="form-control"
                  type="text"
                  disabled="disabled"
                  v-model="qualityPlanStatus.planCode"
                />
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">{{$t('lbl.qualityPlan.planDate')}}:</label>
                <input
                  class="form-control"
                  type="text"
                  disabled="disabled"
                  v-model="qualityPlanStatus.planDateStr"
                />
              </div>

              <div class="form-group col-md-2">
                <label class="control-label">{{$t('lbl.qualityPlan.planPlant')}}:</label>
                <input
                  class="form-control"
                  type="text"
                  disabled="disabled"
                  v-model="qualityPlanStatus.locName"
                />
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">{{$t('lbl.qualityPlan.planShift')}}:</label>
                <input
                  class="form-control"
                  type="text"
                  disabled="disabled"
                  v-model="qualityPlanStatus.planShift"
                />
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">{{$t('lbl.qualityPlan.itemName')}}:</label>
                <input
                  class="form-control"
                  type="text"
                  disabled="disabled"
                  v-model="qualityPlanStatus.itemName"
                />
              </div>
            </div>
          </form>
        </div>
      </div>

      <div id="qualityDataTable" class="content">
        <div class="card my-1">
          <div
            id="collapseTwo"
            class="collapse show"
            aria-labelledby="headingTwo"
            data-parent="#accordionResult"
          >
            <div class="card-body">
              <div class="bs-component"></div>
              <mmf-table
                entity="qualityData"
                inline-actions-disabled
                :singleChoice="true"
                disableEdit
                disableDelete
              >
                <div slot="btnList" class="btn-group" slot-scope="slotProps">
                  <b-button
                    v-b-modal.modal-1
                    variant="outline-primary"
                    :disabled="slotProps.checkedLength!=1"
                  >
                    <i class="fa fa-pencil-alt" aria-hidden="true"></i>
                    <span class="text">{{$t('btn.qualityData.receive')}}</span>
                  </b-button>
                  <button
                    :disabled="slotProps.checkedLength!=1"
                    v-bind:class="'btn btn-outline-primary btn-sm'"
                    v-on:click="Details(entity)"
                  >
                    <i class="fa fa-cog" aria-hidden="true"></i>
                    <span class="text">{{ $t("btn.qualityData.details") }}</span>
                  </button>
                </div>
              </mmf-table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <b-modal id="modal-1" title="样品接收" @ok="receive('qualityData')">
      <b-container fluid>
        <b-row class="mb-1 text-center">
          <b-col>{{$t('lbl.qualityData.person')}}</b-col>
          <!-- <b-col>{{$t('lbl.qualityData.time')}}</b-col> -->
        </b-row>
        <b-row class="mb-2">
          <b-col>
            <input class="form-control" type="text" v-model="person" />
          </b-col>
          <!-- <b-col>
            <mmf-datetimepicker v-model="time"></mmf-datetimepicker>
          </b-col> -->
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from "vuex-map-fields";
import {
  gridFields,
  filterFields
} from "@/model/prd/qualityMgt/pelletizing/QualityData";
import { fields } from "@/model/prd/qualityMgt/pelletizing/QualityData";
import MmfTable from "@/components/MmfTable";
// import MmfDatetimepicker from "@/components/MmfDatetimepicker";

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
  getterType: "qualityData/getField",
  mutationType: "qualityData/updateField"
});

export default {
  name: "qualityDataList",
  data() {
    return {
      person: "",
    };
  },
  components: { MmfTable },
  computed: {
    // generate and add getters and setters using the filter names defined in
    // entity model

    ...mapFields(fields),
    ...mapFields(filterFields),
    ...mapState({
      rows: state => state.qualityData.rows,
      tableColumns: gridFields,
      entity: state => state.qualityData.entity,
      qualityResultEntity: state => state.qualityResult.entity,
      qualityPlanStatus: state => state.qualityData.qualityPlanStatus,
     baseModuleUrl :state=>state.qualityData.baseModuleUrl

    })
  },
  methods: {
    ...mapActions("qualityData", ["Receive", "Details"]),
    ...mapActions("qualityResult", ["Check"]),
    ...mapActions("base", ["MMFLoadRows", "MMFClearFilter"]),
    receive(moudle) {
      this.entity.checkPerson = this.person;
      this.Receive(moudle);
    },
    clear(){
      this.person="";
    },
    loadLows(){
      this.statusFilter="R"
      this.MMFLoadRows("qualityData");

    }
   
  },
  mounted() {
    
    const context = this.$store;
    const id = this.$route.query.id; // 从当前的路由中获取参数 id
    const baseModuleUrl = this.baseModuleUrl;

    context.dispatch("api/get", {
        url:
          baseModuleUrl +
          "/qualityPlan/findById/" +
          id
      })
      .then(response => {
        context.commit("qualityData" + "/setRows", response.qualityDatas);
        context.dispatch("qualityData/qualityPlanStatus", response);
      });
      this.loadLows();
      // this.clear();
      
  },

};
</script>
